import * as modalGlobal from '../global/modal';

const generateMessage = () => [
  {
    id: 'general-covid',
    title: 'Medidas Covid-19',
    message: `<ul>
      <li>La entrega se realizará en la puerta de la casa, local o apartamento.</li>
      <li>El transportista entregará con guantes, tapabocas y tendrá alcohol en gel.</li>
      <li>El transportista deberá desembalar los artículos fuera de la casa, local o apartamento.</li>
      @extraMessage@
      <li>Quien reciba, deberá revisar los productos y firmar la conformidad con su lapicera, teniendo en cuenta
      que no admitiremos reclamos posteriores.</li></ul>`,
  },
  {
    id: 'condiciones-entrega',
    title: 'Condiciones de entrega',
    message: `<ul>
      <li>Transportista</li>  
      <ol>
        <li><b>El horario pactado no puede acotarse.</b> En algunas zonas, disponemos de horario personalizado (costo extra)</li>
        <li><b>El servicio es puerta a puerta</b>, no incluye colocación, instalación o traslado dentro del hogar.
        </li>
        <li><b>En edificios</b>, por escalera y si el espacio es amplio para hacerlo con facilidad, <b>subimos la mercadería hasta el 3er. piso</b>. 
        </li>
      </ol>  
      <li>Cliente</li>  
      <ol>
        <li>Durante todo el <b>horario pactado</b> debe haber un <b>adulto responsable</b> para recibir la compra. Si no hay personas o no disponen del dinero, el transportista deberá retirarse.
        </li>
        <li>Al momento de recibir la compra deberá:</br>
        - <b>Desembalar y verificar</b> el aspecto externo de la mercadería. </br>
        - Firmar la conformidad teniendo en cuenta que <b>no admitiremos reclamos posteriores</b>.
        </li>
      </ol> 
      @extraMessage@
    </ul>`,
  },
  {
    id: 'reparto-covid',
    title: 'Medidas Covid-19',
    message: `<ul>
      <li>Transportista</li>  
      <ol>
        <li>Realizará la entrega en la puerta de la casa, local o apartamento.</li>
        <li>Desembalará los artículos fuera del domicilio.</li>
        <li>Utilizará tapabocas y tendrá alcohol en gel.</li>
      </ol>  
      <li>Cliente</li>  
      <ol>
        <li>Deberá usar tapabocas al recibir la entrega.</li>
        <li>Deberá revisar los productos y firmar la conformidad con su lapicera, teniendo en cuenta que no admitiremos reclamos posteriores.</li>
      </ol> 
      @extraMessage@
    </ul>`,
  },
  {
    id: 'servicio-instalación-covid',
    title: 'Medidas Covid-19',
    message: `
      <p>Nos adaptamos para combatir la pandemia</p>
      <b>LOS TÉCNICOS:</b>
      <ul>
      <li>Utilizan tapabocas permanentemente</li>
      <li>Higienizan permanentemente sus manos</li>
      <li>No comparten artículos personales</li>
      <li>Desinfectan diariamente los vehículos</li>
      </ul>
      <b>EN EL LUGAR DE LA INSTALACIÓN</b>
      <ul>
      <li>El <b>cliente</b> debe utilizar tapabocas durante toda instalación</li>
      <li>El <b>técnico</b>:</li>
      <ul>
      <li>se desinfecta las manos</li>
      <li>se pone guantes de latex</li>
      <li>desinfecta el calzado</li>
      <li>desinfecta el área de trabajo antes de empezar</li>
      <li>mantiene distancia  mínima de 1.5 m con el cliente</li>
      <li>apoya herramientas sobre la caja del artículo</li>
      <li>limpia y desinfecta el área de trabajo antes de retirarse</li>
      <li>desecha los guantes y la caja del artículo</li>
      <li>se desinfecta las manos nuevamente</li>
      <li>desinfecta herramientas después de cada instalación</li>
      </ul>
      </ul>`,
  },
  {
    id: 'compras-a-crédito',
    title: '',
    message: `<span style="text-align: justify">Por el momento no tenemos implementada la opción de crédito online y 
    solo financiamos en nuestros locales</span>
    <br/>
    <p><b>Requisitos de crédito</b></p>
    <span style="text-align: justify">La solicitud de nuestro crédito por primera vez será muy ágil, si traes lo siguiente:</span>
    <br/>
    <ol style="padding:0px 0px 0px 20px">
        <li>Comprobante de ocupación</li>
        <ul style="padding:0px 0px 0px 20px">
            <li>Si sos empleado podés presentar recibo de sueldo</li>
            <li>Si sos jubilado, recibo de jubilación</li>
            <li>Si sos profesional universitario, carné o justificativo de profesión</li>
            <li>Si sos unipersonal, recibo de pago de BPS o DGI (tu nombre deberá figurar en él)</li>
            <li>Si sos comerciante, planilla de trabajo (tu nombre deberá figurar en ella)</li>
        </ul>
        <li>Justificativo/s de sus referencias de crédito</li>
        <ul style="padding:0px 0px 0px 20px">
            <li>Estado de cuenta de una tarjeta de crédito (no Anda), idealmente acompañado por su recibo de pago</li>
            <li>Si no tenés tarjeta de crédito, podrás presentar los recibos de pagos consecutivos de un crédito en cuotas que hayas realizado por un monto similar al que solicitás con nosotros</li>
        </ul>
    </ol>
    <b>Notas</b>
    </br>
    <span style="text-align: justify">Aportar más datos, por ejemplo, recibo de sueldo de su cónyuge y recibo de pago de la tarjeta, facilitará el otorgamiento del crédito.</span>
    <ul style="padding:0px 0px 0px 20px">
        <li>Los datos deben actualizarse una vez al año</li>
        <li>La primera cuota se abona en el momento (excepto en los planes diferidos)</li>
    </ul>`,
  },
];

export default (
  id, extraMessage, asHtml, bodyStyle = null,
  textConfirm = 'Aceptar', showConfirm = true, actionConfim = null,
  textCancel = 'Cancelar', showCancel = true, actionCancel = null,
) => {
  const messageItems = generateMessage().filter(item => item.id === id);
  let messageItem = null;
  if (messageItems && messageItems.length > 0) {
    // eslint-disable-next-line prefer-destructuring
    messageItem = messageItems[0];
    messageItem.message = messageItem.message.replace('@extraMessage@', extraMessage);
    messageItem.html = asHtml;
    messageItem.bodyStyle = bodyStyle;
    messageItem.textConfirm = textConfirm;
    messageItem.showConfirm = showConfirm;
    messageItem.actionConfim = actionConfim;
    messageItem.textCancel = textCancel;
    messageItem.showCancel = showCancel;
    messageItem.actionCancel = actionCancel;
  }

  modalGlobal.showModal(
    messageItem.title, messageItem.message, asHtml, bodyStyle,
    textConfirm, showConfirm, actionConfim,
    textCancel, showCancel, actionCancel,
  );
};



// WEBPACK FOOTER //
// ./src/common/info-modal/messages.js